import React, { useEffect, useState } from "react";
import "./ThankYouBT.css";

const ThankYouBT = () => {
  return (
    <div className="whats-next-wrapper">
      <div class="thank-you-center">
      <img src='/assets/img/thankyou.png' loading='lazy' class="thank-you-img"/>
      </div>
        <div className="whats-next-container">
          
          <h2 className="whats-next-title">What's Next?</h2>
          
          <div className="card-wrapper">
            <div className="card-header-thankyou">
              <div className="icon-circle">
                <img src='/assets/img/Group 399.png' loading='lazy'/>
              </div>
              <div className="card-text">
                <h3 className="card-heading">Expect a Call Soon</h3>
              </div>
            </div>
            <div className="card-body-thankyou">
              <p className="card-description">
               We have shared your details with the relevant team. They will reach out shortly to understand your requirements and take things forward.
              </p>
            </div>
          </div>

          <div className="card-wrapper">
            <div className="card-header-thankyou">
              <div className="icon-circle">
                <img src='/assets/img/Group 400.png' loading='lazy'/>
              </div>
              <div className="card-text">
                <h3 className="card-heading-one">Please Keep Your Documents Ready</h3>
              </div>
            </div>
            <div className="card-body-thankyou">
              <p className="card-description">Having these ready will save time:</p>
              <div className="document-list-wrapper">
                <ul className="document-list">
                  <li className="document-list-item">Latest Salary Slip</li>
                  <li className="document-list-item">Bank Statements (last 3 months)</li>
                  <li className="document-list-item">Outstanding Letter from existing banks</li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
  );
};

export default ThankYouBT;